:host {
  display: block;
  max-width: 100%;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-labeled-content {
  --label-width-percentage: 37%;
  --value-width-percentage: 63%;
}

gz-labeled-content::part(content) {
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size);
}

gz-labeled-content::part(container) {
  align-items: center;
}

gz-labeled-content[class*='wrapped']::part(content) {
  white-space: normal;
}

gz-copy-to-clipboard::part(container) {
  align-items: center;
}

gz-labeled-content[class*='no-margin-container']::part(container) {
  margin-bottom: 0;
}

.experimental-chip {
  cursor: text;
  margin-left: auto;
}

.inline-text {
  display: inline;
}

gz-button[class*="inline-text"] {
  &::part(button) {
    text-align: start;
    padding: 0;
  }
}
